import { useState } from "react";
import useApi from "../useApi";
import toast from "react-hot-toast";

interface IScheduleDateFilterRes {
  key: string;
  value: string;
}

export interface IScheduleDateRes {
  status: "success" | "fail";
  msg?: string;
  data: { key: string; value: string }[];
}

const useGetScheduleDateFilter = () => {
  const [scheduleDateFilters, setScheduleDateFilters] = useState<
    IScheduleDateFilterRes[]
  >([]);

  const { loading, makeApiCall } = useApi({
    method: "GET",
    url: "/rtm/general/schedule-date-filter",
  });

  const getScheduleDateFilter = async () => {
    const { response, error } = await makeApiCall<
      undefined,
      IScheduleDateRes
    >();

    if (response?.status && response.data) {
      setScheduleDateFilters(response.data);
      return response.data;
    }

    if (error) {
      toast.error(error?.msg);
    }
  };

  return {
    scheduleDateFilters,
    getScheduleDateFilter,
    loading,
  };
};

export default useGetScheduleDateFilter;
